import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'ja' ? 'zh' : 'ja');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center">
              <i className="fas fa-balance-scale text-white text-lg"></i>
            </div>
            <span className="text-xl font-bold text-gray-800">{t('officeName')}</span>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="#home" className="text-sm text-slate-700 hover:text-teal-500 whitespace-nowrap transition-colors">
              {t('home')}
            </a>
            <a href="#services" className="text-sm text-slate-700 hover:text-teal-500 whitespace-nowrap transition-colors">
              {t('services')}
            </a>
            <a href="#pricing" className="text-sm text-slate-700 hover:text-teal-500 whitespace-nowrap transition-colors">
              {t('pricing')}
            </a>
            <a href="#testimonials" className="text-sm text-slate-700 hover:text-teal-500 whitespace-nowrap transition-colors">
              {t('testimonials')}
            </a>
            <a href="#contact" className="text-sm text-slate-700 hover:text-teal-500 whitespace-nowrap transition-colors">
              {t('contact')}
            </a>
            <a href="#faq" className="text-sm text-slate-700 hover:text-teal-500 whitespace-nowrap transition-colors">
              {t('faq')}
            </a>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={toggleLanguage}
              className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border border-teal-500 text-teal-600 hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-translate-2 text-base"></i>
              {i18n.language === 'ja' ? '中文' : '日本語'}
            </button>

            <a 
              href="#contact" 
              className="hidden md:flex bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap items-center gap-2"
            >
              {t('freeConsultation')}
              <i className="ri-arrow-right-line"></i>
            </a>
            
            <button 
              className="md:hidden cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-slate-700`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4 space-y-1">
            <a href="#home" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2.5 text-sm text-slate-700 hover:text-teal-500 hover:bg-teal-50 rounded-lg transition-colors">{t('home')}</a>
            <a href="#services" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2.5 text-sm text-slate-700 hover:text-teal-500 hover:bg-teal-50 rounded-lg transition-colors">{t('services')}</a>
            <a href="#pricing" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2.5 text-sm text-slate-700 hover:text-teal-500 hover:bg-teal-50 rounded-lg transition-colors">{t('pricing')}</a>
            <a href="#testimonials" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2.5 text-sm text-slate-700 hover:text-teal-500 hover:bg-teal-50 rounded-lg transition-colors">{t('testimonials')}</a>
            <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2.5 text-sm text-slate-700 hover:text-teal-500 hover:bg-teal-50 rounded-lg transition-colors">{t('contact')}</a>
            <a href="#faq" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2.5 text-sm text-slate-700 hover:text-teal-500 hover:bg-teal-50 rounded-lg transition-colors">{t('faq')}</a>
            <div className="pt-3 flex flex-col gap-2">
              <button
                onClick={toggleLanguage}
                className="flex items-center gap-2 px-3 py-2.5 text-sm text-teal-600 font-medium border border-teal-500 rounded-lg hover:bg-teal-50 transition-colors cursor-pointer"
              >
                <i className="ri-translate-2"></i>
                {i18n.language === 'ja' ? '中文に切替' : '日本語に切替'}
              </button>
              <a
                href="#contact"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center justify-center gap-2 bg-teal-500 text-white px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-teal-600 transition-colors"
              >
                {t('freeConsultation')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
